import { SharedAriaTelemetryHandler, ISharedAriaTelemetryHandlerParams } from './SharedAriaTelemetryHandler';
import { PlatformDetection } from '@ms/utilities-browser/lib/PlatformDetection';

export type IWebSharedAriaTelemetryHandlerParams = ISharedAriaTelemetryHandlerParams & {};

/**
 * Telemetry handler which bakes in the configuration for using the Shared ARIA tenant in a Web application.
 */
export class WebSharedAriaTelemetryHandler extends SharedAriaTelemetryHandler {
  constructor(params: IWebSharedAriaTelemetryHandlerParams) {
    const platformDetection = new PlatformDetection();

    const {
      context = {}
    } = params;

    super({
      language: window.navigator.language,
      ...params,
      context: {
        BrowserIsMobile: platformDetection.isMobile,
        BrowserMajVer: platformDetection.browserMajor,
        BrowserMinVer: platformDetection.browserMinor,
        BrowserName: platformDetection.browserName,
        BrowserUserAgent: platformDetection.userAgent,
        OSName: platformDetection.osName,
        OSVersion: platformDetection.osVersion,
        ...context
      }
    });
  }
}
